import { useEffect, useRef } from 'react';

/**
 * Modified version of usePrevious from:
 * https://usehooks.com/usePrevious/
 * Allows comparison of last component state to new value.
 * Useful with React's useEffect hook,
 * to determine if action needs to need to be taken (or not)
 * @param value - Value to set as current ref for future comparison
 */
export const usePrevious = <T>(value: T) => {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export default usePrevious;
